const WindowEventNames = {MAXIMIZED:'maximized', MINIMIZED:'minimized', FOCUSSED:'focussed',
	UNMINIMIZED:'unminimized', UNMAXIMIZED:'unmaximized', MOVED:'moved', CLOSED:'closed', 
	WINDOW_CREATED:'windowcreated', WINDOW_DESTROYED:'windowdestroyed', DRAGGED:'dragged', 
	DRAG_STARTED:'dragstarted', RESIZE_STARTED:'resizerstarted', RESIZED:'resized'};
export default WindowEventNames;